<template>
  <div>
    Default home page
  </div>
</template>

<script>
export default {
    name: 'home-view-def',
};
</script>

<style scoped>

</style>
